<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Managed List Data Loading...
  </div>
  <div v-else>
    <div class="animated">
      <basic-heading :title="'Managed List'" class="mb-3">
        <template #right-content>
          <header-button-group :button_config="main_button_config" />
        </template>
      </basic-heading>
      <managed-list-card :managedList="managedList" />
      <managed-list-related-tabs :list_id="id" />
    </div>
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import ManagedListCard from "@/components/lab/managedlists/ManagedListCard";
import AttributeListCollection from "@/collections/lab/AttributeListCollection";
import AttributesListsServerTable from "@/components/lab/attributeslists/AttributesListsServerTable";
import AttributesListTable from "@/components/lab/attributeslists/AttributesListTable";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import ManagedListCollection from "@/collections/lab/ManagedListCollection";
import ManagedSubListsTable from "@/components/lab/managedlists/ManagedSubListsTable";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import BaseServerTable from "@/components/shared/BaseServerTable";
import { AccessControlCheck } from "@/auth/AccessControlCheck";
import { mapActions } from "vuex";
import ManagedListRelatedTabs from "@/components/lab/managedlists/ManagedListRelatedTabs.vue";

export default {
  name: "ManagedListsDetail",
  extends: BaseServerTable,
  components: {
    AttributesListTable,
    AttributesListsServerTable,
    BasicHeading,
    HeaderButtonGroup,
    ManagedListCard,
    ManagedSubListsTable,
    PermissionAlertGate,
    ManagedListRelatedTabs
},
  props: {
    show_columns: {
      type: Array,
      default: () => ["list", "parent_list", "attributes"],
    },
  },
  computed: {
    id() {
      return this.$route.params.id || null;
    },
    managedList() {
      return (
        this.managed_lists &&
        this.managed_lists.find((list) => list.id === this.id)
      );
    },
    managedSubList() {
      const managed_sub_list = [];
      if (this.managedList && this.managedList.children.length) {
        this.managedList.children.forEach((children) => {
          managed_sub_list.push(
            this.managed_lists.find((list) => list.id === children.id)
          );
        });
      }
      return managed_sub_list;
    },
    attributesList() {
      return (
        (this.attributes_lists &&
          this.attributes_lists.filter(
            (list) => list.managed_list_id === this.id
          )) ||
        []
      );
    },
    parentAttributesList() {
      return (
        this.attributes_lists &&
        this.attributes_lists
          .filter((list) => list.managed_list_id === this.managedList.parent_id)
          .map((option) => {
            return {
              id: option.id,
              name: option.value,
            };
          })
      );
    },
    main_button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/managed-lists",
            title: "All Managed lists",
          },
        ],
      };
    },
  },
  data() {
    return {
      loading: true,
      managed_lists_collection: new ManagedListCollection(),
      attributes_lists_collection: new AttributeListCollection(),
      managed_lists: null,
      attributes_lists: null,
      table_config: Object.assign(this.getDefaultTableConfig(), {
        options: {
          headers: {
            list: "List",
            parent_list: "Parent List",
            attributes: "Attributes",
          },
          filterable: false,
        },
      }),
    };
  },
  methods: {
    ...mapActions(["UPDATE_PARENT_ID"]),
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
    async init() {
      await this.fetch();
    },
    fetch() {
      const fetches = [];
      fetches.push(
        this.managed_lists_collection.fetch().then(({ response }) => {
          if (response && response.status === 200 && response.data) {
            this.managed_lists = response.data.data;
          }
        })
      );
      fetches.push(
        this.attributes_lists_collection.fetch().then(({ response }) => {
          if (response && response.status === 200 && response.data) {
            this.attributes_lists = response.data.data;
          }
        })
      );
      return Promise.all(fetches);
    },
  },
  mounted() {
    this.loading = true;
    this.init().then(() => {
      this.UPDATE_PARENT_ID({ parent_id: this.id });
      this.loading = false;
    });
  },
};
</script>
